<template>
  <div class="roul-info">
    <el-dialog title="角色详情" class="roul-info-dialog" :visible.sync="visible" :before-close="infoConfirm">
      <ul class="content">
        <li><label>角色名称</label><span>{{item.name}}</span></li>
        <li><label>创建时间</label><span>{{item.createTime}}</span></li>
        <li><label>更新时间</label><span>{{item.updateTime}}</span></li>
        <li class="content-roul">
          <label>模块权限</label>
          <template v-if="item.menus">
            <span v-for="op in item.menus" :key="op.id">{{op.name}}</span>
          </template>
        </li>
        <li><label>描述</label><span>{{item.desc}}</span></li> 
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="infoConfirm">取 消</el-button>
        <el-button type="primary" @click="infoConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item:{
      type: Object,
      default: {}
    }
  },
  data(){
    return {
      dialogFormVisible: true
    }
  },
  methods: {
    infoConfirm(){
      this.$emit('infoConfirm')
    },
    // 取消

  }
}
</script>

<style lang="scss" scoped>
.roul-info{
  &-dialog{
    /deep/ .content{
      margin-left: 30px;
      li{
        margin-bottom: 35px;
        label{
          width: 120px;
          display: inline-block;
          font-size: 16px;
          font-weight: 500;

        }
        span{
          margin-right: 20px;
          font-size: 16px;
        }
      }
    }
  }
}

</style>